// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTechnologyCheckCloudSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M0 14.793a5.206 5.206 0 0 1 2.703-4.567.264.264 0 0 0 .136-.217 7.346 7.346 0 0 1 12.702-4.628.264.264 0 0 0 .249.077 4.317 4.317 0 0 1 5.215 3.903c.006.089.057.17.135.213A5.563 5.563 0 0 1 18.437 20H5.001C5 20 5 20 5 19.998c0-.001 0-.002-.002-.002A5.208 5.208 0 0 1 0 14.793zm7.227-1.21 2.56 2.56a.389.389 0 0 0 .55 0l5.67-5.67a.389.389 0 0 0 .001-.549l-.548-.552a.389.389 0 0 0-.551 0l-4.847 4.846-1.739-1.732a.389.389 0 0 0-.549.001l-.547.547a.389.389 0 0 0 0 .55z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTechnologyCheckCloudSolid;
